module.exports = __webpack_public_path__ + "assets/img/pike.f2176ab8.png";